import DerivativesStrategiesPreview from "../strategies/strategies-preview/DerivativesStrategiesPreview";
import Grid2 from "@mui/material/Unstable_Grid2";
import { Paper } from "@mui/material";
import DerivativesCommodityMarketFutureContractsLinks from "./DerivativesCommodityMarketFutureContractsLinks";

const DerivativesCommodityMarket = () => {
  return (
    <Grid2 container spacing={2}>
      <Grid2 xs={12}>
        <Paper>
          <DerivativesCommodityMarketFutureContractsLinks />
        </Paper>
      </Grid2>
      <Grid2 xs={12}>
        <Paper>
          <DerivativesStrategiesPreview url="/dashboard/derivatives/commodity-market/strategies" />
        </Paper>
      </Grid2>
    </Grid2>
  );
};

export default DerivativesCommodityMarket;
